<script lang="ts">
  import RatingDots from "./RatingDots.svelte"
  import AUBrandText from "./ui/AUBrandText.svelte"
  import AUText from "./ui/AUText.svelte"

  export let rating: number
  export let ratingText: string
  export let layout: "vertical" | "horizontal"
</script>

<div class="auws-widget-price-rating__wrapper">
  <div
    class="auws-widget-price-rating"
    data-rating={rating}
    data-layout={layout}
  >
    <AUText font="body-small" weight="bold"
      ><AUBrandText>{ratingText}</AUBrandText></AUText
    >
    <div class="auws-price-rating-element"><RatingDots {rating} /></div>
  </div>
</div>

<style>
  .auws-widget-price-rating__wrapper {
    width: 100%;
    container: price-rating / inline-size;
  }

  .auws-widget-price-rating {
    width: 100%;
    display: flex;
    gap: 8px;

    flex-direction: column;
    align-items: start;
  }

  .auws-widget-price-rating[data-layout="horizontal"] {
    /* min width is based on font size and length of the text */
    @container price-rating (min-width: 178px) {
      flex-direction: row;
      align-items: center;
    }
  }

  .auws-widget-price-rating[data-rating="1"] :global(div:first-child) {
    color: #ba1717;
  }

  .auws-widget-price-rating[data-rating="2"] :global(div:first-child) {
    color: #f07f23;
  }

  .auws-widget-price-rating[data-rating="3"] :global(div:first-child) {
    color: #56ac82;
  }

  .auws-widget-price-rating[data-rating="4"] :global(div:first-child) {
    color: #68a52e;
  }

  .auws-widget-price-rating[data-rating="5"] :global(div:first-child) {
    color: #3a835f;
  }
</style>
